<template>
	<div class="keywordnegative">
		<div v-if="isShowList">
			<van-tabs v-model="active" color="#333333" @click="onClick" line-width="125">
				<van-tab title="预设关键词">
					<div class="negative_box" v-for="item in list" :key="'list_' + item.id">
						<div class="negative_list">
							<div class="keyword">关键词</div>
							<div class="keyword_title">
								<span  @click="goWaringInfo(item.id)">{{item.key}}</span>
								<!-- <img class="edit_del" :src="img.edit_del" @click="del_edit(item.id,item.key,index)"> -->
							</div>
							<van-row class="keyword">
								<van-col span="10">首次出现</van-col>
								<van-col class="text-c" span="8">出现频次</van-col>
								<van-col class="text-r" span="6">出现论坛</van-col>
							</van-row>
							<van-row class="keyword_text">
								<van-col span="10">{{item.time}}</van-col>
								<van-col class="text-c" span="8">{{item.num}}次</van-col>
								<van-col class="text-r" span="6">{{item.bbs_num}}个</van-col>
							</van-row>
							<div></div>
						</div>
					</div>
					<div class="negative_state" v-if="list.length>0">
						<img class="level_img" :src="img.level1">
						<div>1-3天内命中预警关键词的帖子，且评论数大于20条。</div>
						<!-- <div>1周内命中预警关键词的新帖子，同时评论数大于5条</div>
							<div>2周内命中预警关键词的新帖子，同时评论数大于15条</div> -->
							<img class="level_img" :src="img.level2">
							<div>1-3天内命中预警关键词的帖子，且评论数大于15条。</div>
							<img class="level_img" :src="img.level3">
							<div>1-3天内命中预警关键词的帖子，且评论数大于10条。</div>
						</div>
						<div class="add_keyword_box" v-if="list.length>0">
							<div class="add_keyword" @click="goMyKeyword()">添加自定义关键词</div>
						</div>
					</van-tab>
					<van-tab title="自定义关键词">
						<div class="negative_box" v-for="(item,index) in lists" :key="'list_' + item.id">
							<div class="negative_list">
								<div class="keyword">关键词</div>
								<div class="keyword_title">
									<span  @click="goWaringInfo(item.id)">{{item.key}}</span>
									<img class="edit_del" :src="img.edit_del" @click="del_edit(item.id,item.key,index)">
								</div>
								<van-row class="keyword">
									<van-col span="10">首次出现</van-col>
									<van-col class="text-c" span="8">出现频次</van-col>
									<van-col class="text-r" span="6">出现论坛</van-col>
								</van-row>
								<van-row class="keyword_text">
									<van-col span="10">{{item.time}}</van-col>
									<van-col class="text-c" span="8">{{item.num}}次</van-col>
									<van-col class="text-r" span="6">{{item.bbs_num}}个</van-col>
								</van-row>
							</div>
						</div>
						<div class="add_keyword_box">
							<div class="add_keyword" @click="goMyKeyword()">添加自定义关键词</div>
						</div>
					</van-tab>
				</van-tabs>

				<van-action-sheet v-model="showSheet" cancel-text="取消"
				close-on-click-action :actions="actions" @select="onSelect" />
			</div>
			<van-overlay :show="show">
				<div class="wrapper">
					<div class="keywordcustom">
						<div class="text_box">
							<van-field
							v-model="content"
							rows="6"
							type="textarea"
							maxlength="500"
							placeholder="请输入关键词"
							show-word-limit
							/>
						</div>
						<div class="choose_term">
							<div style="flex: 1"></div>
							<div class="search_close" @click="closePop()">取消</div>
							<div class="search_btn" @click="saveKey()">提交</div>
						</div>
						<div class="tips">温馨提示：</div>
						<div class="tips">若输入多项关键词内容，请在内容之间使用英文逗号“,”隔开，或换行进行区分</div>
					</div>
				</div>
			</van-overlay>
			<van-popup v-model="popShow">
				<div class="popTitle">
					<div>您添加的关键词【{{popKeword}}】已存在</div>
					<div>请查看预设关键词列表</div>				
				</div>
				<div class="popBtn" @click="popShow=false">知道了</div>
			</van-popup>
		</div>

	</template>

	<script>
		import admin from '../../api/admin';
		import { mapState } from 'vuex';
		import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,Tab, Tabs,ActionSheet,Overlay,Dialog } from 'vant';
		export default {
			data () {
				return {
					isShowList:true,
					showSheet:false,
					active:0,
					content:'',
					text:'',
					list:[],
					lists:[],
					actions: [{ name: '编辑' }, { name: '删除' }],
					params:{
						type:1
					},
					show:false,
					popShow:false,
					popKeword:'',
					img:{
						hot:require('../../assets/img/hot.png'),
						new: require('../../assets/img/new.png'),
						level1: require('../../assets/img/level1.png'),
						level2: require('../../assets/img/level2.png'),
						level3: require('../../assets/img/level3.png'),
						edit_del:require('../../assets/img/edit_del.png'),
						close: require('../../assets/img/close.png'),
					}
				}
			},
			computed: {
				...mapState({
					user: state => state.param.user
				})
			},
			created () {
				if(this.$route.query.token){
					this.token = this.$route.query.token
					this.$store.dispatch('param/setToken', this.$route.query.token)
					this.getNewKeywordList()

				// if(localStorage.getItem('editKeyactive')){
				// 	this.getNewKeywordLists()
				// 	this.active = 1
				// 	this.params.type=2
				// 	localStorage.removeItem('editKeyactive')
				// }else{
				// 	this.getNewKeywordList()
				// }
			}
		},
		methods: {
			onClick(name) {
				if(name==0){
					this.params.type=1
					this.getNewKeywordList()
				}else{
					this.params.type=2
					this.getNewKeywordLists()
				}
			},
			del_edit(id,key,index){
				this.showSheet=true
				this.id=id
				this.index=index
				this.content=key
			},
			onSelect(item) {
				this.showSheet = false;
				if(item.name=='删除'){
					var params={
						id:this.id
					}
					admin.DelKeyword(params).then(res => {
						if(res.data.state==1){
							this.lists.splice(this.index,1);
							this.id=''
							this.content=''
						}else{

						}

					})
				}else if(item.name=='编辑'){
					// var params={
					// 	id:this.id,
					// 	content:this.keyname
					// }
					this.show=true
					// var item=JSON.stringify(params);
					// localStorage.setItem('editKey', item)
					// localStorage.setItem('editKeyactive', 1)
					// setTimeout(function(){
					// 	wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordcustom'})
					// },200);
				}
			},
			getNewKeywordList(){

				admin.getNewKeywordList(this.params).then(res => {
					if(res.data.state==1){
						this.list=res.data.data
					}else{

					}

				})
			},
			getNewKeywordLists(){

				admin.getNewKeywordList(this.params).then(res => {
					if(res.data.state==1){
						this.lists=res.data.data
					}else{

					}

				})
			},
			saveKey(val) {
				if(this.id){
					var params={
						id:this.id,
						content:this.content
					}
					admin.editKey(params).then(res => {
						if(res.data.state==1){
							this.getNewKeywordLists()
							this.show=false
							this.id=''
							this.content=''
							
						}else{

						}
					})
				}else{
					var params={
						content:this.content
					}
					admin.addKey(params).then(res => {
						if(res.data.state==1){
							if(res.data.data.keyword){
								this.popKeword=res.data.data.keyword
								this.popShow=true
							}else{
								this.active = 1
								this.params.type=2
								this.getNewKeywordLists()
								this.show=false
								this.content=''
							}
							
							// wx.miniProgram.navigateBack({delta:1})
							// wx.miniProgram.reLaunch({url:'/pages/webview/webview?scene=keywordnegative'})
						}else{

						}
					})
				}
			},
			goMyKeyword(){
				this.getNewKeywordLists()
				this.active = 1
				this.params.type=2
				this.show=true
				// localStorage.setItem('editKeyactive', 1)
				// wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordcustom'})
			},
			goWaringInfo(id){
				// wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordnegativeinfo/'+id})
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordnegativeinfo/'+id})
				

			},
			closePop() {
				this.show=false
				this.id=''
				this.index=''
				this.content=''
			},
			


		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Tab.name]:Tab,
			[Tabs.name]:Tabs,
			[Icon.name]:Icon,
			[ActionSheet.name]:ActionSheet,
			[Overlay.name]:Overlay,
			[Dialog.name]:Dialog
		}
	}
</script>
<style lang="scss">
.keywordnegative{
	padding: 15px;
	.van-tabs--line .van-tabs__wrap{
		border-bottom: 1px solid #EEEEEE;
	}
	.van-tabs__nav--line{
		padding: 0 50px 15px 50px;
	}
	.negative_box{
		border:1px solid #BBBBBB;
		border-radius:4px;
		margin-top: 15px;
		padding:2px 12px;
		.negative_list{
			padding:5px 10px;
			background-color: #F8F8F8;
			margin: 10px 0;
			.keyword{
				font-size: 8px;
				color: #666666;
			}
			.keyword_title{
				font-size: 12px;
				color: #666666;
				border-bottom:1px solid #EEEEEE;
				padding:5px 0;
				margin-bottom: 5px;
				.edit_del{
					width: 54px;
					height: 16px;
					float: right;
				}
			}
			.keyword_text{
				color: #666666;
				font-size: 12px;

			}
		}
	}
	.negative_state{
		color: #666666;
		padding:10px;
		font-size: 10px;
		.level_img{
			width: 36px;
			height: 16px;
		}
	}
	.add_keyword_box{
		text-align: center;
		padding:20px 45px;
		.add_keyword{
			font-weight: 500;
			padding:7px 0;
			font-size: 12px;
			color: #666666;
			border:1px solid #666666;
			border-radius:4px;
		}
	}
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
	.keywordcustom{
		background-color:#fff;
		padding:20px;
		margin: 20px;
		position:relative;
		border-radius: 4px;
		.pop_close{
			width: 16px;
			height: 16px;
			position:absolute;
			right: 6px;
			top: 6px;

		}
		.text_box{
			border: 1px solid #BBBBBB;
			border-radius: 4px;
			// margin-top: 15px;
			.van-cell{
				font-size: 14px;
				background-color: transparent;
			}
		}
		.choose_term{
			display: flex;
			align-items: center;
			font-size: 12px;
			margin-bottom: 20px;
			.time_btn{
				border-radius:4px;
				border:1px solid #666666;
				color: #000000;
				margin: 5px;
				padding:6px 12px;
			}
			.time_btn_active{
				background-color:#666666;
			}
			.search_btn{
				color: #fff;
				border:1px solid #333333;
				background-color: #333333;
				border-radius:4px;
				margin: 5px;
				padding:6px 18px;
			}
			.search_close{
				color: #000;
				border:1px solid #BBBBBB;
				background-color: #BBBBBB;
				border-radius:4px;
				margin: 5px;
				padding:6px 18px;
			}
		}
		.tips{
			font-size: 12px;
			color: #666666;
		}
	}
	.van-popup{
		width: 280px;
		height: 150px;
		font-size: 14px;
		border-radius:10px;
		text-align: center;
		.popTitle{
			padding: 30px 0;
			border-bottom: 1px solid #eaeaea;
		}
		.popBtn{
			padding: 15px 0;
		}
	}
}

</style>